<div class="d-flex flex-wrap p-4 layout-bg align-items-center justify-content-center vh-100">
    <div class="text-center">
        <h1 class="display-1 fw-bold">401</h1>
        <p class="fs-3"> <span class="text-danger">Opps!</span> Access Denied.</p>
        <p class="lead">
            ขออภัย คุณไม่มีสิทธิ์ในการเข้าถึงหน้าที่ร้องขอ กรุณาตรวจสอบใหม่อีกครั้ง
        </p>
        <button (click)="goBackToIntranetWeb()" class="btn btn-primary">กลับสู่หน้าหลัก</button>
    </div>
</div>